module.exports = __webpack_public_path__ + "img/amazon.de.71b57c11.jpg";